import { render, staticRenderFns } from "./Phones.vue?vue&type=template&id=5598772a&scoped=true"
import script from "./Phones.vue?vue&type=script&lang=ts"
export * from "./Phones.vue?vue&type=script&lang=ts"
import style0 from "./Phones.vue?vue&type=style&index=0&id=5598772a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5598772a",
  null
  
)

export default component.exports